<div class="d-title" [ngStyle]="{ paddingLeft: config.paddingLeft, fontSize: config.fontSize, color: config.color, weight: config.weight }">
  {{ config.label }}
</div>
